exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__NumberField__root,\n.DS__NumberField__input {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__NumberField__root {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.DS__NumberField__input {\n  width: 36px;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #222a37;\n  text-align: center;\n  background: none;\n  border: none;\n  -moz-appearance: textfield;\n}\n\n.DS__NumberField__input::-webkit-inner-spin-button,\n  .DS__NumberField__input::-webkit-outer-spin-button {\n    margin: 0;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__NumberField__root",
	"input": "DS__NumberField__input"
};